import { Size } from '@lumapps/lumx/react';

export const MAX_PROFILE_PICTURE_SIZE = '32MB';

export const FORM_SUBSECTION_VERTICAL_ORIENTATION_SIZES: Size[] = [Size.xxs, Size.xs, Size.s];
